// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/views/Blog/CardGroup.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/views/Blog/CardGroup.tsx");
  import.meta.hot.lastModified = "1732036225892.2214";
}
// REMIX HMR END

import Button from "~/components/Button";
import BlogTeaser from "./BlogTeaser";
import clsx from "clsx";
import Heading from "~/components/Heading";
export default function CardGroup({
  items,
  variant,
  title,
  text,
  ctaSingle
}) {
  return <section className={clsx("grid w-full gap-10 md:gap-8", variant === "secondary" ? "grid-cols-2" : "grid-cols-3")}>
      {variant !== "secondary" && <article className="flex flex-col gap-4 col-span-3 md:col-span-1">
          <Heading tag="h2">{title}</Heading>
          <div className="text-neutral-600" dangerouslySetInnerHTML={{
        __html: text.processed
      }} />
          {ctaSingle && <Button className="w-fit" to={ctaSingle.url} variant="secondary">
              {ctaSingle.title}
            </Button>}
        </article>}
      {items.map(blog => <BlogTeaser key={blog.title} item={blog} variant="card" />)}
    </section>;
}
_c = CardGroup;
var _c;
$RefreshReg$(_c, "CardGroup");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;